import { UserControllerApi } from "src/api/api";

export interface IUserApiClients {
    user: UserControllerApi;
}

export class UserApiClients {
    private static instance: IUserApiClients;

    private constructor() { }

    static getInstance(basePath: string): IUserApiClients {
        if (UserApiClients.instance == null) {
            UserApiClients.instance = {
                user: new UserControllerApi({
                    basePath: basePath,
                    isJsonMime() {
                        return true;
                    }
                }),
            };
        }
        return UserApiClients.instance;
    }
}

